import API from "./api";

export const GetAppConfigs = (configFileName: string) =>
  API.getApi(configFileName);
